'use strict';

var cssUnits = require('../helpers/css-units.js');

const breakpoints = {
    s: cssUnits.pxToEm('600px'),
    m: cssUnits.pxToEm('1024px'),
    l: cssUnits.pxToEm('1440px'),
};
const devices = {
    mobile: { max: breakpoints.s },
    tablet: { min: cssUnits.pxToEm(cssUnits.emToPx(breakpoints.s) + 1), max: breakpoints.m },
    laptop: { min: cssUnits.pxToEm(cssUnits.emToPx(breakpoints.m) + 1), max: breakpoints.l },
    desktop: { min: cssUnits.pxToEm(cssUnits.emToPx(breakpoints.l) + 1) },
};
const makeMediaQuery = (widths) => {
    const query = [widths.min && `(min-width: ${widths.min})`, widths.max && `(max-width: ${widths.max})`]
        .filter(Boolean)
        .join(' and ');
    return `@media ${query}`;
};
const makeMediaQueries = (mediaDevices) => {
    const entries = Object.entries(mediaDevices).map(([name, widths]) => [name, makeMediaQuery(widths)]);
    return Object.fromEntries(entries);
};
const mediaQueryFor = (device) => ({ theme }) => theme.deviceMediaQueries[device];

exports.breakpoints = breakpoints;
exports.devices = devices;
exports.makeMediaQueries = makeMediaQueries;
exports.makeMediaQuery = makeMediaQuery;
exports.mediaQueryFor = mediaQueryFor;
//# sourceMappingURL=breakpoints.js.map
